export default {
  setReportType({ commit }, type) {
    commit("SET_REPORT_TYPE", type);
  },
};
